/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { AuthChangeEvent, createClient, Session, SupabaseClient, User } from '@supabase/supabase-js';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { debounceTime } from 'rxjs/operators';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class SupaService {

  public supabase: SupabaseClient;
  public CreateRecordByParam: BehaviorSubject<number> = new BehaviorSubject<number>(-1);
  public LoginObject: BehaviorSubject<UserPermissions | undefined> = new BehaviorSubject<UserPermissions | undefined>(undefined);
  public UnreadNotificationCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private debouceLoginSubject = new Subject<User | null>();

  constructor(private http: HttpClient, private toastController: ToastController, private router: Router, private ngZone: NgZone) {
    console.log('Supa service constructor');
    this.supabase = createClient(environment.supabaseUrl, environment.supabaseKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    });
    this.supabase.auth.getUser().then(async ({ data }) => {
      console.log('supabase.auth.getUser()');
      this.debouceLoginSubject.next(data.user);
    })
    this.supabase.auth.onAuthStateChange(async (_getEventTarget, session) => {
      console.log('supabase.auth.onAuthStateChange');
      this.debouceLoginSubject.next(session?.user ?? null);
    });
    this.debouceLoginSubject.pipe(debounceTime(200)).subscribe(async (u) => {
      console.log('Debounced invocation of user sign in.');
      console.log('User -> ', u);
      if (u == null) {
        this.ngZone.run(() => {
          this.LoginObject.next(undefined);
        });
      } else {
        console.log('Fetching related employee data', u.id);
        const employeeData = await this.supabase
          .from('employee')
          .select('user_id,email,name,profile_img,role:role_id(*)')
          .eq('user_id', u.id)
          .maybeSingle()
          .throwOnError();
        if (employeeData.error) {
          console.log('employeeData.error');
          (await toastController.create({message: 'Could not load an employee for this user.', color: 'danger'})).present();
          this.supabase.auth.signOut();
        } else if (employeeData.data == null || (Array.isArray(employeeData.data) && employeeData.data.length != 1)) {
          console.log('employeeData.data == null');
          (await toastController.create({message: 'Could not load employee data for this user.', color: 'danger'})).present();
          this.supabase.auth.signOut();
        } else {
          const newUiUser = {
            email: employeeData.data.email,
            id: employeeData.data.user_id,
            name: employeeData.data.name,
            profile_img: employeeData.data.profile_img,
            role: Array.isArray(employeeData.data.role) ? (employeeData.data.role.length == 1 ? employeeData.data.role[0] : {}) : employeeData.data.role,
          };
          console.log('Got the new ui user. proceeding', newUiUser);
          this.ngZone.run(() => {
            this.LoginObject.next({
              email: newUiUser.email,
              employee_id: newUiUser.id,
              fullname: newUiUser.name,
              id: newUiUser.id,
              permissions: [
                'VhcAllLocations',
                'VhcCanOpen',
                'VhcFollowUpMenu',
                'VhcLocationsMenu',
                'VhcRecordsDeactivate',
                'VhcRecordsManageAuth',
                'VhcRecordsManageJP',
                'VhcRecordsManageLocation',
                'VhcRecordsManageMPI',
                'VhcRecordsManagePre',
                'VhcRecordsManageQI',
                'VhcRecordsView',
                'VhcReportsMenu',
                'VhcSettingsComponents',
                'VhcSettingsFinancial',
                'VhcSettingsMenu',
                'VhcSettingsSystem',
                'VhcVehiclesCreateRecord',
                'VhcVehiclesManage',
                'VhcVehiclesMenu',
              ],
              updated_at: new Date()
            })
          });
          // signed in

          // check if new jc that wants a record..
          const params = new URLSearchParams(window.location.search);
          const jobcardId = params.get("pleaseMakeRecordWithJcId");
          const jcId = jobcardId ? Number(jobcardId) : null;

          if (jobcardId) {
            params.delete("pleaseMakeRecordWithJcId");
            const newUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
            window.history.replaceState({}, "", newUrl);
            
            this.CreateRecordByParam.next(jcId);
          }
        }
      }
    })
  }

  public signOut() {
    this.LoginObject.next(undefined);
    return this.supabase.auth.signOut();
  }

  public async ExternalConfig(): Promise<any> {
    return {};
  }

  // Responsible for applications dynamic settings.
  public async Settings(): Promise<JSettings> {
    const s = await this.supabase.from('settings').select('vhc_red_days,vhc_amber_days,vhc_lang_1_name,vhc_lang_1_code,vhc_lang_2_enabled,vhc_lang_2_name,vhc_lang_2_code,vhc_lang_1_currency,vhc_lang_2_currency,vhc_default_tax,vhc_video_calls,vhc_external_config,vhc_max_time_pre,vhc_max_time_mpi,vhc_max_time_jp,vhc_max_time_auth,vhc_max_time_qi,vhc_max_time_pre_jp,vhc_max_time_pre_auth').single();
    console.log(s);
    if (s.data == null) {
      this.signOut();
      return {} as any;
    }
    return {
      reddays: s.data.vhc_red_days,
      amberdays: s.data.vhc_amber_days,
      lang1name: s.data.vhc_lang_1_name,
      lang1code: s.data.vhc_lang_1_code,
      lang2enabled: s.data.vhc_lang_2_enabled,
      lang2name: s.data.vhc_lang_2_name,
      lang2code: s.data.vhc_lang_2_code,
      lang1currency: s.data.vhc_lang_1_currency,
      lang2currency: s.data.vhc_lang_2_currency,
      defaulttax: s.data.vhc_default_tax,
      videocalls: s.data.vhc_video_calls,
      externalconfig: s.data.vhc_external_config,
      maxtimepre: s.data.vhc_max_time_pre,
      maxtimempi: s.data.vhc_max_time_mpi,
      maxtimejp: s.data.vhc_max_time_jp,
      maxtimeauth: s.data.vhc_max_time_auth,
      maxtimeqi: s.data.vhc_max_time_qi,
      maxtimeprejp: s.data.vhc_max_time_pre_jp,
      maxtimepreauth: s.data.vhc_max_time_pre_auth,
    }
  }

  // Code for easy user mapping
  userListCache = new Map<string, { fullname: string; employee_id: string }>();
  userListCacheDate = 0;
  public async getUserList(): Promise<Map<string, { fullname: string; employee_id: string }>> {
    const now = new Date().getTime();
    if (now - this.userListCacheDate < 60000) {
      console.log('Loaded users from cache');
      return this.userListCache;
    }
    console.log('Loading new user list');
    const { data, error } = await this.supabase.from('vhc_userpermissions').select('id,fullname,employee_id');
    if (error) {
      console.error(error);
    } else {
      // eslint-disable-next-line prefer-const
      let _userListCache = new Map<string, { fullname: string; employee_id: string }>();
      data.forEach(u => {
        _userListCache.set(u.id, { fullname: u.fullname, employee_id: u.employee_id });
      });
      this.userListCache = _userListCache;
      this.userListCacheDate = now;
      return this.userListCache;
    }
  }
}

export interface UserPermissions {
  email: string;
  fullname: string;
  id: string;
  permissions: string[];
  employee_id: string;
  updated_at: Date;
}

export interface IQTask {
  Duration: number;
  Order: string;
  Name: string;
  Type: string;
  Employabilities: number[];
  BaseId: string;
  Team: boolean;
}

export interface JSettings {
  id?: number;
  reddays: number;
  amberdays: number;
  lang1name: string;
  lang1code: string;
  lang1currency: string;
  lang2enabled: boolean;
  lang2name: string;
  lang2code: string;
  lang2currency: string;
  defaulttax: number;
  externalconfig: number;
  videocalls: string;
  maxtimepre: number;
  maxtimempi: number;
  maxtimejp: number;
  maxtimeauth: number;
  maxtimeqi: number;
  maxtimeprejp: number;
  maxtimepreauth: number;
}

export interface IQWorkOrderData {
  appointmentRef: string; // Only relevant the first PUT because it will convert our dummy to a real job card
  dmsId: string;
  masterJC: string;
  woType: string;
  description: string;
  remarks: string;
  vehicleId: string; // VIN
  licensePlate: string;
  engineCode: string;
  mileage: number;
  carType: string;
  yearOfBuild: number;
  preferedMechanic: string;
  preferedReceptionist: string;
  customerCity: string;
  customerName: string;
  customerAddress: string;
  customerPhone: string;
  tasks: IQWorkOrderDataJob[];
}

export interface IQWorkOrderDataJob {
  duration: number; // In minutes
  code: string;
  name: string;
}
